/* eslint-disable max-len,no-irregular-whitespace,no-console,no-undef */
import React from 'react';
import { Link } from 'gatsby';
import firebase from 'firebase';
import { navigate } from '@reach/router';
import Layout from '../../components/Layout';
import SEO from '../../components/seo';
import './style.scss';
import getCloudinary from '../../utils/getCloudinary';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';


const PERSONAL_STEP = 0;
const PASSWORD_STEP = 1;
const SignUpPage = () => {
    const [signUpStep, setSignUpStep] = React.useState(PERSONAL_STEP);
    const [personalInfo, setPersonalInfo] = React.useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
    });
    const [error, setError] = React.useState(null);
    const updatePersonalInfo = changeAttributes => setPersonalInfo({ ...personalInfo, ...changeAttributes });

    const onClickSignUp = async () => {
        const signUpResponse = await firebase.auth().createUserWithEmailAndPassword(
            personalInfo.email,
            personalInfo.password,
        ).catch((signUpError) => {
            console.log('signUpError');
            console.log(signUpError);
            switch (signUpError.code) {
            case 'auth/email-already-in-use':
                setError('This email is already in use');
                break;
            default:
                break;
            }
        });

        console.log('signUpResponse', signUpResponse);
        if (signUpResponse && signUpResponse.user) {
            const { firstName, lastName } = personalInfo;
            await signUpResponse.user.updateProfile({
                displayName: `${firstName} ${lastName}`,
            })
                .then(() => navigate('/'))
                .catch(updateInfoError => console.log(updateInfoError));

            firebase.database().ref(`users/${signUpResponse.user.uid}`)
                .set({ firstName, lastName })
                .then(writeResult => console.log('writeResult', writeResult))
                .catch(writeError => console.log('writeError', writeError));
        }
    };

    let screenWidth = 0;
    if (typeof window !== 'undefined') {
        screenWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    }

    return (
        <Layout id="sign-up-page">
            <SEO title="DR WATSON | Login" />

            <div className="nav-bar-below-content">
                <div
                    className="main-sign-up-container"
                    style={{
                        backgroundImage: `url("${getCloudinary().url(
                            'dashboard-uploads/oil_coffee_fixed_pavxaa',
                            { width: screenWidth, crop: 'fit', fetch_format: 'auto' },
                        )}")`,
                    }}
                >
                    <div className="dimmed-container">
                        <DrWatsonLargeLogo white className="mb-3" />
                        <div className="card">
                            <div className="card-content">
                                {
                                    signUpStep === PASSWORD_STEP && (
                                        <div
                                            className="is-flex align-items-center go-back-container"
                                            onClick={() => setSignUpStep(PERSONAL_STEP)}
                                        >
                                            <i
                                                className="fas fa-angle-left has-text-white go-back-arrow"
                                                aria-hidden="true"
                                            />
                                            <div
                                                className="title is-size-6-touch is-size-5-desktop has-text-white has-text-centered is-uppercase letter-spacing-0-1 ml-1"
                                            >
                                                Go Back
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="content">
                                    <div
                                        className="title is-size-4-touch is-size-3-desktop has-text-centered has-text-white has-text-centered is-uppercase letter-spacing-0-1"
                                    >
                                        Sign Up
                                    </div>
                                </div>


                                <div className="login-form">

                                    {
                                        error && (
                                            <div
                                                className="subtitle is-size-6-touch is-size-5-desktop mb-4 has-text-danger has-text-centered"
                                            >
                                                {error}
                                            </div>
                                        )
                                    }

                                    {
                                        signUpStep === PERSONAL_STEP
                                        && (
                                            <>
                                                <div
                                                    className="is-size-5-touch is-size-4-desktop has-text-white has-text-centered is-spaced mb-4"
                                                >
                                                    We just need some information about yourself for our service towards you.
                                                </div>
                                                <div className="field has-addons mb-2">
                                                    <p className="control">
                                                        <div
                                                            className="button is-static is-medium has-background-info has-text-white"
                                                        >
                                                            First Name
                                                        </div>
                                                    </p>
                                                    <p className="control">
                                                        <input
                                                            className="input is-medium"
                                                            type="text"
                                                            value={personalInfo.firstName}
                                                            onChange={e => updatePersonalInfo({
                                                                firstName: e.target.value,
                                                            })}
                                                        />
                                                    </p>
                                                </div>

                                                <div className="field has-addons mb-2">
                                                    <p className="control">
                                                        <div
                                                            className="button is-static is-medium has-background-info has-text-white"
                                                        >
                                                            Last Name
                                                        </div>
                                                    </p>
                                                    <p className="control">
                                                        <input
                                                            className="input is-medium"
                                                            type="text"
                                                            value={personalInfo.lastName}
                                                            onChange={e => updatePersonalInfo({
                                                                lastName: e.target.value,
                                                            })}
                                                        />
                                                    </p>
                                                </div>

                                                <div className="field has-addons mb-2">
                                                    <p className="control">
                                                        <div
                                                            className="button is-static is-medium has-background-info has-text-white"
                                                        >
                                                            Email
                                                        </div>
                                                    </p>
                                                    <p className="control">
                                                        <input
                                                            className="input is-medium"
                                                            type="email"
                                                            value={personalInfo.email}
                                                            onChange={e => updatePersonalInfo({
                                                                email: e.target.value,
                                                            })}
                                                        />
                                                    </p>
                                                </div>

                                            </>
                                        )
                                    }
                                    {
                                        signUpStep === PASSWORD_STEP
                                        && (
                                            <>
                                                <div
                                                    className="title is-size-5-touch is-size-4-desktop has-text-white has-text-centered is-spaced"
                                                >
                                                    Enter a password to secure your account
                                                </div>
                                                <div
                                                    className="subtitle is-size-6-touch is-size-5-desktop mb-4 has-text-white has-text-centered"
                                                >
                                                    {`Don't worry, you can
                                        login without it with our passwordless login!`}
                                                </div>
                                                <div className="field has-addons">
                                                    <p className="control">
                                                        <div
                                                            className="button is-static is-medium has-background-info has-text-white"
                                                        >
                                                            Password
                                                        </div>
                                                    </p>
                                                    <p className="control">
                                                        <input
                                                            className="input is-medium"
                                                            type="password"
                                                            value={personalInfo.password}
                                                            onChange={e => updatePersonalInfo({
                                                                password: e.target.value,
                                                            })}
                                                        />
                                                    </p>
                                                </div>
                                            </>
                                        )
                                    }

                                    <div className="is-flex justify-content-flex-end align-items-center mt-1">
                                        {
                                            signUpStep === PERSONAL_STEP
                                            && (
                                                <button
                                                    type="button"
                                                    className="button is-success is-medium"
                                                    onClick={() => setSignUpStep(PASSWORD_STEP)}
                                                >
                                                    Continue
                                                </button>
                                            )
                                        }
                                        {
                                            signUpStep === PASSWORD_STEP
                                            && (
                                                <button
                                                    type="button"
                                                    className="button is-success is-medium"
                                                    onClick={onClickSignUp}
                                                >
                                                    Sign Up
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                                {
                                    signUpStep === PERSONAL_STEP
                                    && (
                                        <div className="is-flex align-items-center justify-content-flex-end">
                                            <div className="is-size-5-touch is-size-4-desktop mr-1 has-text-white">
                                                or
                                            </div>
                                            <div>
                                                <Link
                                                    to="login"
                                                    className="button is-info is-medium"
                                                >
                                                    Log In
                                                </Link>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
export default SignUpPage;
